export const getSteps = (referrerFirstName: string) => [
  {
    title: "Claim your gift",
    text: `Tell us where you're moving. It takes 60 seconds and confirms ${referrerFirstName} referred you.`,
  },
  {
    title: "We handle the rest",
    text: "As soon as your move goes through, we confirm it automatically - no action needed from you.",
  },
  {
    title: "A certified tech installs it",
    text: "We schedule your free professional install at a time that works for you.",
  },
]

export const GIFT_FEATURES = [
  {
    title: "Control it from anywhere",
    text: "Adjust the temperature, set schedules, and switch on away mode from the free iOS and Android app.",
  },
  {
    title: "Learns your routine",
    text: "Automatically eases back when you're out and warms up before you're home — about $140 saved a year.",
  },
  {
    title: "Free install & warranty",
    text: "A certified tech mounts and configures it in one 45-minute visit, backed by a 12-month warranty.",
  },
]

export const FAQ_ITEMS = [
  {
    question: "Is this really free?",
    answer:
      "Yes, completely free. The smart thermostat and the professional installation are both covered, with no hidden charges and nothing to pay later. It is a housewarming gift arranged through your real estate agent as part of our referral program.",
  },
  {
    question: "What if it doesn't fit my system?",
    answer:
      "Most standard heating and cooling systems are compatible. Our team confirms compatibility with you before scheduling, and the installer verifies it on site. If your system turns out not to be compatible, there is no charge and nothing else you need to do.",
  },
  {
    question: "How much will I actually save?",
    answer:
      "Savings vary by home and usage, but our thermostats are ENERGY STAR certified. Smart scheduling, remote control from your phone, and efficiency features typically cut heating and cooling costs by around 8 percent for the average household.",
  },
  {
    question: "Who installs it?",
    answer:
      "A licensed local contractor from our professional installation network. Once your claim is confirmed, our team reaches out to schedule a time that works for you, and the contractor handles the installation end to end.",
  },
  {
    question: "Do I need to create an account?",
    answer:
      "Not to claim your thermostat. Just submit the form on this page. When your thermostat is installed, we set up your free account so you can control it from your phone with our app.",
  },
  {
    question: "Is my information shared?",
    answer:
      "No. Your details are used only to process your claim, confirm it with your real estate agent, and arrange your installation with the assigned contractor. We never sell your information. Your agent can see the status of your claim, but never your thermostat or account data.",
  },
]
